import AmexGDA, { ComponentAmexGDAUnderTest } from './AmexGDA';

export default AmexGDA;

export {
  ComponentAmexGDAUnderTest,
};
